export default "__VITE_ASSET__jwWL2N8U__"